/**
 * Nurse Missed Visit — static options + empty form state.
 * Sections mirror Eval & Orders → Nurse Missed Visit screenshots.
 */

import { emptyNurseNotesCommonHeader } from "./nurseNotesCommonHeaderUtils";
import { emptyWoundAssessmentValues } from "./woundAssessmentContent";

export const GENDER_OPTIONS = ["Male", "Female", "Other", "Unknown"];

export const MISSED_REASON_OPTIONS = [
  "Patient Refused Service",
  "Patient Hospitalized/ER",
  "Patient Not Home / No Answer",
  "Agency Conflict / Staffing",
  "Inclement Weather",
  "Equipment Not Available",
];

export const ATTEMPT_METHOD_OPTIONS = [
  "Phone Call",
  "Home Visit",
  "Text Message",
  "Voicemail",
  "Email",
  "Other",
];

export const RISK_LEVEL_OPTIONS = ["Low", "Moderate", "High", "Critical"];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const INTERVENTION_OPTIONS = [
  "Medication Management / Review",
  "Wound Care / Dressing Change",
  "Patient Teaching & Training",
  "Vital Sign Monitoring",
  "Lab Draw / Specimen Collection",
  "Catheter / IV Care",
];

export const NOTIFY_METHOD_OPTIONS = [
  "Phone",
  "Fax",
  "Portal",
  "In Person",
  "Email",
  "Voicemail",
  "Other",
];

export const DISCIPLINE_OPTIONS = ["PT", "OT", "ST", "MSW", "HHA"];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const newAttemptLogId = () =>
  `attempt-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;

export const emptyAttemptLog = () => ({
  id: newAttemptLogId(),
  dateTime: "",
  method: "Phone Call",
  outcome: "",
});

/** Full editable Nurse Missed Visit payload (JSON on dedicated row). */
export const emptyRnMissedVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  commonHeader: emptyNurseNotesCommonHeader(),

  fullName: "",
  dateOfBirth: "",
  gender: "",
  mrn: "",
  homeAddress: "",
  phone: "",
  missedVisitDate: "",

  missedReasons: [],
  reasonExplanation: "",

  attemptLogs: [],

  riskHospitalization: "",
  riskClinicalDecline: "",
  safetyConcern: [],
  clinicalImpactSummary: "",

  ...emptyWoundAssessmentValues(),

  interventionsAffected: [],
  functionalImpact: "",

  caseManagerName: "",
  caseManagerMethod: "",
  caseManagerDate: "",
  physicianName: "",
  physicianMethod: "",
  physicianDate: "",
  caregiverName: "",
  caregiverMethod: "",
  caregiverDate: "",

  rescheduledDate: "",
  nextScheduledFrequency: "",
  mitigationStrategy: "",
  otherDisciplines: [],
});

export const today = () => new Date().toISOString().slice(0, 10);
